// extracted by mini-css-extract-plugin
module.exports = {"container":"plan-card_container__ixNua","styled-list":"plan-card_styled-list__NUMX9","title":"plan-card_title__FSgqx","text":"plan-card_text___TM2_"};